import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./components/dashboard/Dashboard";
import UserList from "./components/user/UserList";
import UserDetail from "./components/user/UserDetail";
import ChangePassword from "./components/user/ChangePassword";
import Login from "./components/login/Login";
import CategoryList from "./components/category/CategoryList";
import CategoryDetail from "./components/category/CategoryDetail";
import BrandDetail from "./components/brand/BrandDetail";
import BrandList from "./components/brand/BrandList";
import UnitList from "./components/unit/UnitList";
import UnitDetail from "./components/unit/UnitDetail";
import ProductGroupList from "./components/product-group/ProductGroupList";
import ProductGroupDetail from "./components/product-group/ProductGroupDetail";
import WarehouseDetail from "./components/warehouse/WarehouseDetail";
import WarehouseList from "./components/warehouse/WarehouseList";
import ProductDetail from "./components/product/ProductDetail";
import ProductList from "./components/product/ProductList";
import StockTransferDetail from "./components/stock-transfer/StockTransferDetail";
import StockTransferList from "./components/stock-transfer/StockTransferList";
import StockInDetail from "./components/stockin/StockInDetail";
import StockInList from "./components/stockin/StockInList";
import TaxList from "./components/tax/TaxList";
import TaxDetailList from "./components/tax/TaxDetail";
import StockAdjustmentList from "./components/stock-adjustment/StockAdjustmentList";
import StockAdjustmentDetail from "./components/stock-adjustment/StockAdjustmentDetail";
import CounterCashList from './components/counter-cash/CounterCashList';
import CounterCashDetail from "./components/counter-cash/CounterCashDetail";
import StockTakeList from "./components/stock-take/StockTakeList";
import StockTakeRegister from "./components/stock-take/StockTakeRegister";
import StockBalanceList from "./components/stock-balance/StockBalanceList"
import CounterCashReport from "./components/counter-cash/CounterCashReport";
import SystemSerializeList from "./components/system-serialize/SystemSerializeList";
import SystemSerializeDetail from "./components/system-serialize/SystemSerializeDetail";
import CashInHandReport from "./components/cash-in-hand/CashInHandReport";
import SaleReport from "./components/sale-report/SaleReport";
import StockReturnReport from "./components/stock-return-report/StockReturnReport";
import MenuReport from "./components/menu-report/MenuReport";

import ShiftInfoList from "./components/shift-info/ShiftInfoList";
import ShiftInfoDetail from "./components/shift-info/ShiftInfoDetail";
import ShiftAssignList from "./components/shift-assign/ShiftAssignList";
import ShiftAssignDetail from "./components/shift-assign/ShiftAssignDetail";
import ShopList from "./components/shop/ShopList";
import ShopDetail from "./components/shop/ShopDetail";
import CounterList from "./components/counter/CounterList";
import CounterDetail from "./components/counter/CounterDetail";
import CurrencyList from "./components/currency/CurrencyList";
import CurrencyDetail from "./components/currency/CurrencyDetail";
import CurrencyExchangeList from "./components/currency-exchange-rate/CurrencyExchangeList";
import CurrencyExchangeDetail from "./components/currency-exchange-rate/CurrencyExchangeDetail"

import SaleList from "./components/sale/SaleList";
import CreditLevelDetail from "./components/credit-level/CreditLevelDetail";
import CreditLevelList from "./components/credit-level/CreditLevelList";
import CustomerDetail from "./components/customer/CustomerDetail";
import CustomerList from "./components/customer/CustomerList";

import PurchaseOrderList from "./components/purchase-order/PurchaseOrderList"
import PurchaseOrderDetail from "./components/purchase-order/PurchaseOrderDetail"

import PriceModelList from "./components/price-model/PriceModelList";
import PriceModelDetail from "./components/price-model/PriceModelDetail";

import SupplierList from "./components/supplier/SupplierList";
import SupplierDetail from "./components/supplier/SupplierDetail";

import SaleReturn from "./components/sale-return/SaleReturn"

import WholeSaleList from "./components/whole-sale/WholeSaleList";
import WholeSaleDetail from "./components/whole-sale/WholeSaleDetail";
import CreditCashFlowList from "./components/credit-cash-flow/CreditCashFlowList";
import CustomerCreditBalanceList from "./components/customer-credit-balance/CustomerCreditBalanceList";
import StockValuationReport from "./components/stock-valuation-report/StockValuationReport";
import DiscountList from "./components/discount/DiscountList";
import DiscountDetail from "./components/discount/DiscountDetail";
import StockMovementReport from "./components/stock-movement/StockMovementReport"
import SalePersonSaleList from "./components/sale/SalePersonSaleList";
import CardList from "./components/card/CardList";
import CardDetail from "./components/card/CardDetail";
import SalePersonSaleReport from "./components/sale-report/SalePersonSaleReport";
import CashNoteList from "./components/cash-note/CashNoteList";
import CashNoteDetail from "./components/cash-note/CashNoteDetail";
import DenominationList from "./components/demonination/DenominationList";
import DenominationDetail from "./components/demonination/DenominationDetail";
import CashReport from "./components/cash-report/CashReport";
import AccountReceivableReport from "./components/account-receivable-report/AccountReceivableReport";

Vue.use(Router);

export const router = new Router({
  routes: [
    { path: "/", redirect: "/dashboard" },
    { path: "/dashboard", name: "dashboard", component: Dashboard },

    { path: "/users", name: "users", component: UserList },
    { path: "/users/:id", name: "users-detail", component: UserDetail },
    {
      path: "/change-password",
      name: "change-password",
      component: ChangePassword
    },

    { path: "/categories", name: "categories", component: CategoryList },

    {
      path: "/category/:id",
      name: "category-detail",
      component: CategoryDetail
    },
    {
      path: "/brand/:id",
      name: "brand-detail",
      component: BrandDetail
    },

    {
      path: "/brands",
      name: "brands",
      component: BrandList
    },

    { path: "/units", name: "units", component: UnitList },
    {
      path: "/unit/:id",
      name: "unit-detail",
      component: UnitDetail
    },

    {
      path: "/product-groups",
      name: "product-groups",
      component: ProductGroupList
    },
    {
      path: "/product-group/:id",
      name: "product-group-detail",
      component: ProductGroupDetail
    },

    {
      path: "/products",
      name: "products",
      component: ProductList
    },
    {
      path: "/product/:id",
      name: "product-detail",
      component: ProductDetail
    },

    {
      path: "/stock-transfers",
      name: "stock-transfers",
      component: StockTransferList
    },
    {
      path: "/stock-transfer/:id",
      name: "stock-transfer-detail",
      component: StockTransferDetail
    },

    {
      path: "/warehouse/:id",
      name: "warehouse-detail",
      component: WarehouseDetail
    },

    { path: "/warehouses", name: "warehouses", component: WarehouseList },
    {
      path: "/stockin/:id",
      name: "stockin-detail",
      component: StockInDetail
    }, {
      path: "/stockins",
      name: "stockins",
      component: StockInList
    },

    { path: "/taxs", name: "taxs", component: TaxList },
    { path: "/taxs/:id", name: "taxs-detail", component: TaxDetailList },


    {
      path: "/stock-adjustment/:id",
      name: "stock-adjustment-detail",
      component: StockAdjustmentDetail
    },

    {
      path: "/stock-adjustments",
      name: "stock-adjustments",
      component: StockAdjustmentList
    },

    {
      path: '/counter-cashs',
      name: 'counter-cashs',
      component: CounterCashList
    },

    {
      path: "/counter-cash/:id",
      name: "countercash-detail",
      component: CounterCashDetail
    },

    {
      path: "/stock-takes",
      name: "stock-takes",
      component: StockTakeList
    },
    {
      path: "/stock-take-register",
      name: "stock-take-register",
      component: StockTakeRegister
    },

    { path: "/stock-balances", name: "stock-balances", component: StockBalanceList },

    {
      path: "/counter-cash-report",
      name: "counter-cash-report",
      component: CounterCashReport
    },

    {
      path: "/sale-report",
      name: "sale-report",
      component: SaleReport
    },

    {
      path: "/stock-return-report",
      name: "stock-return-report",
      component: StockReturnReport
    },

    {
      path: '/system-serializes',
      name: 'system-serializes',
      component: SystemSerializeList
    },

    {
      path: "/system-serialize/:id",
      name: "system-serialize-detail",
      component: SystemSerializeDetail
    },

    {
      path: "/cash-in-hand-report",
      name: "cash-in-hand-report",
      component: CashInHandReport
    },


    { path: "/shift-infos", name: "shift-infos", component: ShiftInfoList },
    { path: "/shift-info/:id", name: "shift-info-detail", component: ShiftInfoDetail },

    { path: "/menu-report", name: "menu-report", component: MenuReport },

    { path: "/shift-assigns", name: "shift-assigns", component: ShiftAssignList },
    { path: "/shift-assign/:id", name: "shift-assign-detail", component: ShiftAssignDetail },
    { path: "/shops", name: "shops", component: ShopList },
    { path: "/shop/:id", name: "shop-detail", component: ShopDetail },
    { path: "/counters", name: "counters", component: CounterList },
    { path: "/counter/:id", name: "counter-detail", component: CounterDetail },

    { path: "/currencies", name: "currencies", component: CurrencyList },
    { path: "/currency/:id", name: "currency", component: CurrencyDetail },

    { path: "/currency-exchange-rates", name: "currency-exchange-rates", component: CurrencyExchangeList },
    { path: "/currency-exchange-rate/:id", name: "currency-exchange-rate", component: CurrencyExchangeDetail },

    { path: "/sales/:id", name: "sales", component: SaleList },

    { path: "/purchase-order", name: "purchase-order", component: PurchaseOrderList },
    { path: "/purchase-order/:id", name: "purchase-order-detail", component: PurchaseOrderDetail },

    {
      path: "/credit-level/:id",
      name: "credit-level-detail",
      component: CreditLevelDetail
    },
    { path: "/credit-levels", name: "credit-levels", component: CreditLevelList },

    {
      path: "/customer/:id",
      name: "customer-detail",
      component: CustomerDetail
    },
    { path: "/customers", name: "customers", component: CustomerList },

    {
      path: "/supplier/:id",
      name: "supplier-detail",
      component: SupplierDetail
    },
    { path: "/suppliers", name: "suppliers", component: SupplierList },

    { path: "/price-model/:id", name: "price-model-detail", component: PriceModelDetail },
    { path: "/price-models", name: "price-models", component: PriceModelList },
    { path: "/sale-return", name: "sale-return", component: SaleReturn },


    {
      path: "/whole-sale/:id",
      name: "whole-sale-detail",
      component: WholeSaleDetail
    },

    { path: "/discounts", name: "discounts", component: DiscountList },

    { path: "/discount/:id", name: "discount-detail", component: DiscountDetail },

    { path: "/whole-sales", name: "whole-sales", component: WholeSaleList },

    { path: "/credit-cash-flows", name: "CreditCashFlows", component: CreditCashFlowList },

    { path: "/customer-credit-balance", name: "CustomerCreditBalance", component: CustomerCreditBalanceList },

    { path: "/stock-valuation-report", name: "StockValuationReport", component: StockValuationReport },
    { path: "/stock-movement-report", name: "stock-movement-report", component: StockMovementReport },

    { path: "/saleperson-sales", name: "SalePersonSaleList", component: SalePersonSaleList },

    { path: "/cards", name: "cards", component: CardList },

    { path: "/card/:id", name: "card-detail", component: CardDetail },

    { path: "/saleperson-sale-report", name: "SalePersonSaleReport", component: SalePersonSaleReport },

    { path: "/cash-notes", name: "cash-notes", component: CashNoteList },
    { path: "/cash-note/:id", name: "card-note-detail", component: CashNoteDetail },

    { path: "/denominations", name: "denominations", component: DenominationList },
    { path: "/denomination/:id", name: "denomination-detail", component: DenominationDetail },

    { path: "/cash-report", name: "cash-report", component: CashReport },

    { path: "/account-receivable-report", name: "account-receivable-report", component: AccountReceivableReport },

    { path: "/login", name: "login", component: Login },
    { path: "*", redirect: "/" } // otherwise redirect to home

  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("accessToken");

  if (authRequired && !loggedIn) {
    return next("/login");
  } else if (!authRequired && loggedIn) {
    return next("/"); //prevent login reloading event
  }

  next();
});
